<script setup lang="ts">
import Credit from "~/components/forms/Credit.vue";
import CreditAlt from "~/components/forms/CreditAlt.vue";
import StepCards from "~/components/static/StepCards.vue";

const { locale: formLocale } = await useLocale("forms", null, true);
const { locale: homeLocale } = await useLocale("ui", null, true);

const emit = defineEmits(["init","submit"]);

onMounted(() => {emit("init")})

const creditForm: Component = useTemplateRef('credit-form');

	const focusCreditSelect = () => {
	window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
	setTimeout(() => {
		creditForm.value?.focusSelect();
	}, 400);
};

</script>

<template>
  <div class="bg-gray-1 unicredit-home">
    <header class="flex justify-center bg-white">
      <div>
        <img src="@/themes/unicredit/assets/img/logo.svg" alt="Logo Cofidis" class="w-40"/>
      </div>
    </header>
    <Credit 
        ref="credit-form"
        :values="getCreditValues()" 
        :cta-text="formLocale?.credit.labels.submit"
        :cta-subtext="formLocale?.credit.labels.ctaSubmit" 
        @submit="emit('submit')"
      >
      <template #title>
        <span v-html="formLocale?.credit.title"></span>
      </template>
      <template #subtitle>
        <span class="subtitle" v-html="formLocale?.credit.subtitle"></span>
      </template>
      <template #text><span v-html="formLocale?.credit.text"></span></template>
    </Credit>

    <!-- Banner-->
    <div class="relative">
      <div class="bg-white w-full h-1/2 absolute top-1/2 z-0"></div>
      <div class="icons-banner z-1 relative">
        <div class="banner-item">
          <div>
            <IconsRataFissaRed />
          </div>
          <p class="text-white text-xl font-semibold">Rata fissa</p>
        </div>
        <div class="banner-item">
          <div>
            <IconsPhoneRed />
          </div>
          <p class="text-white text-xl font-semibold">100% online</p>
        </div>
        <div class="banner-item">
          <div>
            <IconsFlashRed />
          </div>
          <p class="text-white text-xl font-semibold max-w-[128px]">Prevalutazione immediata</p>
        </div>
      </div>
    </div>

    <!-- Section steps -->
    <StepCards :cta="homeLocale?.home.section_steps.button_text" :steps="homeLocale?.home.section_steps.steps"
      @click="focusCreditSelect">
      <template #title>
        <span>{{ homeLocale?.home.section_steps.title }}</span>
      </template>
    </StepCards>

    <!--  Credit alt form  -->
    <CreditAlt :cta-text="formLocale?.credit_alt.button.submit" :cta-subtext="formLocale?.credit_alt.button.ctaSubmit"
      :values="getCreditValues()" @submit="emit('submit')">
      <template #title>
        <span class="text-3xl">{{ formLocale?.credit_alt.title }}</span>
      </template>
      <template #text>
        <span>{{ formLocale?.credit_alt.subtitle }}</span>
      </template>
      <template #helper_text>
        <span>{{ formLocale?.credit_alt.helper_text }}</span>
      </template>
    </CreditAlt>
  </div>
</template>
